module.exports = __webpack_public_path__ + "img/video06.755c771b.jpeg";